/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class PlpRoute extends Route {
  // Services
  @service
  store;

  model() {
    let store = this.store;

    return hash({
      categories: store.query('goals/category', { isPLP: true }),
      subcategories: store.query('goals/subcategory', { isPLP: true }),
      schools: store.findAll('school'),
    });
  }
}
